import { createAsyncThunk } from '@reduxjs/toolkit';
import BrokerApi from '@infrastructure/broker-api';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const addBrokerAsync = createAsyncThunk('broker/add', async (broker, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await BrokerApi.addBroker(broker);
        dispatch(addSuccessNotification(translate('broker.brokerCreatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getBrokersAsync = createAsyncThunk('broker/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await BrokerApi.getBrokers();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getBrokerByIdAsync = createAsyncThunk('broker/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await BrokerApi.getBrokerById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBrokerAsync = createAsyncThunk('broker/update', async (broker, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await BrokerApi.updateBroker(broker);
        dispatch(addSuccessNotification(translate('broker.brokerUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const deleteBrokerAsync = createAsyncThunk('broker/delete', async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        await BrokerApi.deleteBroker(id);
        dispatch(addSuccessNotification(translate('broker.brokerDeletedSuccessfully')));
        dispatch(getBrokersAsync());
        return fulfillWithValue(true);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
